export enum NumberOfEmployees {
  SelfEmployed = 'SelfEmployed',
  OneToTen = 'OneToTen',
  TenToFifty = 'TenToFifty',
  FiftyToOneHundred = 'FiftyToOneHundred',
  OneHundredToFiveHundred = 'OneHundredToFiveHundred',
  FiveHundredToOneThousand = 'FiveHundredToOneThousand',
  OneThousandToFiveThousand = 'OneThousandToFiveThousand',
  FiveThousandToTenThousand = 'FiveThousandToTenThousand',
  TenThousandToFiftyThousand = 'TenThousandToFiftyThousand',
  FiftyThousandToOneHundredThousand = 'FiftyThousandToOneHundredThousand',
  OneHundredThousandToTwoHundredThousand = 'OneHundredThousandToTwoHundredThousand',
  TwoHundredThousandToThreeHundredThousand = 'TwoHundredThousandToThreeHundredThousand',
  MoreThanThreeHundredThousand = 'MoreThanThreeHundredThousand',
}

export const NumberOfEmployeesDescriptor = Object.freeze({
  [NumberOfEmployees.SelfEmployed]: 'Self Employed',
  [NumberOfEmployees.OneToTen]: '1-10',
  [NumberOfEmployees.TenToFifty]: '10-50',
  [NumberOfEmployees.FiftyToOneHundred]: '50-100',
  [NumberOfEmployees.OneHundredToFiveHundred]: '100-500',
  [NumberOfEmployees.FiveHundredToOneThousand]: '500-1,000',
  [NumberOfEmployees.OneThousandToFiveThousand]: '1,000-5,000',
  [NumberOfEmployees.FiveThousandToTenThousand]: '5,000-10,000',
  [NumberOfEmployees.TenThousandToFiftyThousand]: '10,000-50,000',
  [NumberOfEmployees.FiftyThousandToOneHundredThousand]: '50,000-100,000',
  [NumberOfEmployees.OneHundredThousandToTwoHundredThousand]: '100,000-200,000',
  [NumberOfEmployees.TwoHundredThousandToThreeHundredThousand]: '200,000-300,000',
  [NumberOfEmployees.MoreThanThreeHundredThousand]: '300,000+',
});
